import { Flex } from '@npco/zeller-design-system'

import { ReactComponent as HLLogo } from 'assets/svg/logos/HL.svg'

export const HLIcon = () => (
  <Flex height="48px" justifyContent="center" alignItems="center">
    <HLLogo width={40} height={40} />
  </Flex>
)
